<template>
  <aside
    class="qr-code-panel new-design"
  >
    <div class="background">
    </div>
    <div class="content">
      <img
        v-if="canUseXmasDecoration"
        src="@/assets/images/logos/tree.svg"
        width="100"
        class="absolute top-0 left-0 img-top"
      >
      <div class="qr-code-panel__header">
        <a class="close-button " @click="closeQrCode" v-tooltip="$i18nPresenter.t('Close QR code')">
          <aha-icon
            name="close"
            viewBox="0 0 24 24"
            width="16"
            height="16"
          />
        </a>
      </div>
      <div class="qr-code">
        <QrCode v-if="permanentLink" />
      </div>
      <div class="join-link">
        <p class="join-at">
          {{ $t('Join at:') }}
        </p>
        <div class="audience-link" v-tooltip="audienceLinkTooltip" @click="onClickAudienceLink">
          <div v-if="isWhiteLabel">
            <p class="white-label-link">
              {{ accessCodeDomain }}/<strong>{{ accessCode }}</strong>
            </p>
          </div>
          <div v-else>
            <p class="access-code-domain">
              {{ accessCodeDomain }}/
            </p>
            <p class="access-code">
              {{ accessCode }}
            </p>
          </div>
        </div>
      </div>
      <img
        v-if="canUseXmasDecoration"
        src="@/assets/images/logos/qr-bottom.svg"
        class="absolute left-0 bottom-0 img-bottom"
      >
    </div>

    <div></div>
  </aside>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import QrCode from '@/components-v2/common/qr-code/QrCode.vue'
import Config from '@/config'
import util from '@/util'
import constants from '@/constant'
import ToggleQRCodeMixin from '@/mixins/presentation/ToggleQRCodeMixin'

let domainAudienceTopCanvas = 'ahaslides.com'
if (Config.region === constants.euRegion) {
  domainAudienceTopCanvas = 'ahaslides.eu'
}
export default {
  components: {
    QrCode,
  },
  mixins: [ToggleQRCodeMixin],
  data() {
    return {
      isMSTeamsApp: window.location.href.includes('ms-teams'),
      domainAudienceTopCanvas,
      hasCopiedAudienceLink: false,
    }
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseXmasDecoration']),
    ...mapState({
      presentation: (state) => state.presentation,
      accessCode: (state) => state.presentation.accessCode,
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
    }),
    permanentLink() {
      if (!this.presentation.whiteLabelLink) {
        return `https://${Config.audienceLink}/${this.presentation.uniqueAccessCode}`
      }
      return `https://${this.presentation.whiteLabelLink}/${this.presentation.uniqueAccessCode}`
    },
    accessCodeDomain() {
      return `${this.presentation.whiteLabelLink || domainAudienceTopCanvas}`
    },
    audienceLinkTooltip() {
      if (this.isMSTeamsApp) {
        return
      }
      const tooltipContent = this.hasCopiedAudienceLink ? this.$i18nPresenter.t('Copied') : this.$i18nPresenter.t('Click to copy link')
      return {
        content: tooltipContent,
        delay: { show: 0, hide: this.hasCopiedAudienceLink ? 600 : 10 },
        offset: -5,
      }
    },
    isWhiteLabel() {
      return this.currentUser && this.currentUser.plan === 'white-label' && this.presentation.whiteLabelLink
    },
  },
  methods: {
    closeQrCode() {
      this.toggleQrCode('QR code panel') // ToggleQRCodeMixin
    },
    onClickAudienceLink(e) {
      e.stopPropagation()

      if (this.isMSTeamsApp) {
        return
      }
      navigator.clipboard.writeText(`https://${this.presentation.whiteLabelLink ||
                this.domainAudienceTopCanvas}/${this.presentation.accessCode}`)

      this.hasCopiedAudienceLink = true
      setTimeout(() => {
        this.hasCopiedAudienceLink = false
      }, 1500)
      util.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Presenting > Copy audience link')
    },
  },
}

</script>
<style lang="scss" scoped>
  .background {
    @apply bg-secondary-60;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    @apply text-primary-20;
  }
.qr-code-panel {
  height: 80%;
  width: 20%;
  position: absolute;
  background: #fff;
  top: 10%;
  left: 0;
  z-index: 901;
  border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.qr-code-panel__header {
  height: 48px;
  margin-bottom:16px;
  .close-button {
    @apply cursor-pointer float-right p-2 text-secondary-20 rounded-full flex items-center justify-center w-8 h-8;
    margin: 6px;
    font-size: 0.8em;
    background-color: rgba(0, 0, 0, 0.36);
  }
}

.qr-code {
  padding: 16px;
  margin-bottom: 32px;
}
.join-link {
  font-family: Nunito;
  .join-at {
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .access-code-domain {
    font-size: 30px;
    text-align: center;
  }

  .access-code {
    font-weight: bold;
    font-size: 30px;
    text-align: center;

  }
}
.audience-link {
  cursor: pointer;
}

.white-label-link {
  overflow-wrap: break-word;
  padding: 0 12px;
  font-size: 24px;
  text-align: center;
}
.img-bottom {
  border-bottom-left-radius: 8px;
}
.img-top {
  border-top-left-radius: 8px;
}
</style>
